<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default"
    [opened]="!isScreenSmall" *ngIf="usrDtls && usrDtls.rle_nm !=  'BCCFC Benificary '">
    <ng-container fuseVerticalNavigationContentHeader>

        <div class="flex items-center justify-center" *ngIf="clntTntDtls && clntTntDtls.length"
            style="height: 0px; background : #fff;    border-right: 2px solid #e7e7e7;margin: 50px;">
            <img style="width: 100%; margin-top: 0px; height: 64px;" [src]="PrfieImage" *ngIf="fullimg">
            <img style="width: 100%; margin-top: 0px; height: 64px;" [src]="PrfieImage" *ngIf="lgimg">
            <!-- <img style="width: 100%; margin-top: 0px; height:75px " [src]="clntTntDtls[0].dsply_lgo_url_tx" *ngIf="fullimg">
            <img style="width:64px;height:64px ; margin: 0px auto;" [src]="clntTntDtls[0].dsply_lgo_url_tx"
                *ngIf="lgimg"> -->
        </div>
    </ng-container>
</fuse-vertical-navigation>


<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 bg-gray-100">

    <!-- Header -->
    <div *ngIf="showMainHeader" class="bc-img relative flex flex-0 items-center w-full px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden mblevw_hdr_bgrnd"
        [ngClass]="usrDtls && usrDtls.rle_nm ==  'BCCFC Benificary ' ? 'pstnAbs' : ' '">
        <div class="flex items-center pr-2 space-x-2" *ngIf="usrDtls && usrDtls.rle_nm !=  'BCCFC Benificary '">
            <!-- Navigation toggle button -->
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
            <!-- Navigation appearance toggle button -->
            <button class="hidden md:inline-flex" mat-icon-button (click)="toggleNavigationAppearance()">
                <mat-icon [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
            </button>
        </div>

        <div class="flex flex-1 justify-between">
            <div class="flex-container justify-center gap-2 w-full">
                <div *ngIf="usrDtls['clnt_id'] == 1000053">
                    <img src="/assets/images/ramanaidu.png"
                        style="margin: 5px; width: 65px; border-radius: 50%; box-shadow: 2px 2px 8px #44556673;">
                </div>
                <div class="client-name">
                    {{clntTntDtls[0].clnt_nm}}
                    <div *ngIf="usrDtls && usrDtls.rle_nm !=  'BCCFC Benificary '">
                        <div style="    margin-top: -2px;margin-bottom: 10px;">

                            <span *ngIf="usrDtls['dprt_nm']" class="relative inline-block">
                                <div class="flex items-center cursor-pointer group" (click)="toggleDeptDropdown()">
                                    <div style="background: #d5e9f9;"
                                        class="flex items-center space-x-2 rounded-lg px-3.5 py-1 transition-all duration-200 border border-blue-200 hover:border-indigo-300">
                                        <div class="w-7 h-7 rounded-full bg-white/90 flex items-center justify-center">
                                            <mat-icon
                                                class="text-blue-600 group-hover:text-indigo-600 w-5 h-5 transition-colors">business</mat-icon>
                                        </div>
                                        <span
                                            class="text-sm font-semibold text-gray-800 group-hover:text-gray-900">{{selectedDept?.dprt_nm
                                            || usrDtls['dprt_nm']}}</span>
                                        <div class="flex flex-col items-center" *ngIf="departments?.length>1">
                                            <div
                                                class="flex items-center space-x-1 px-2 py-0.5 rounded-md bg-white/80 group-hover:bg-white">
                                                <mat-icon
                                                    class="text-blue-500 group-hover:text-indigo-600 w-4 h-4 transition-colors"
                                                    [svgIcon]="'heroicons_outline:switch-horizontal'">
                                                </mat-icon>
                                                <span
                                                    class="text-xs font-medium text-blue-600 group-hover:text-indigo-600">Switch</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Dropdown Menu -->
                                <div *ngIf="showDeptDropdown" style="width: 414px !important;"
                                    class="absolute right-0 mt-1.5  bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 transform origin-top-right transition-all duration-200 ease-out">
                                    <div class="divide-y divide-gray-100">
                                        <div class="px-3 py-2 flex items-center bg-gray-50 rounded-t-lg">
                                            <div class="p-1 rounded-md bg-indigo-50">
                                                <mat-icon class="w-3.5 h-3.5 text-indigo-600"
                                                    [svgIcon]="'heroicons_outline:switch-horizontal'">
                                                </mat-icon>
                                            </div>
                                            <span class="ml-2 text-sm font-medium text-gray-700">Switch
                                                Department</span>
                                            <div class="p-1 rounded-md bg-indigo-50 switch-close-icon" (click)="toggleDeptDropdown()">
                                                <mat-icon class="w-3.5 h-3.5 text-indigo-600">close
                                                </mat-icon>
                                            </div>
                                        </div>
                                        <div class="max-h-48 overflow-y-auto py-1">
                                            <!-- *ngIf="all" -->
                                            <div *ngIf="all"
                                                class="flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-indigo-50 cursor-pointer transition-colors duration-150"
                                                [class.bg-indigo-50]="selectedDept==0"
                                                (click)="selectDepartment('all')">
                                                <span class=" flex-1">All Departments</span>
                                                <div *ngIf="selectedDept==0"
                                                    class="ml-2 flex-shrink-0 p-0.5 rounded-full bg-indigo-100">
                                                    <mat-icon class="w-3.5 h-3.5 text-indigo-600">check</mat-icon>
                                                </div>
                                            </div>
                                            <div *ngFor="let dept of departments"
                                                class="flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-indigo-50 cursor-pointer transition-colors duration-150"
                                                [class.bg-indigo-50]="dept.pst_id === selectedDept?.pst_id"
                                                (click)="selectDepartment(dept)">
                                                <span class=" flex-1">{{dept.dprt_nm}}</span>
                                                <div *ngIf="dept.pst_id === selectedDept?.pst_id"
                                                    class="ml-2 flex-shrink-0 p-0.5 rounded-full bg-indigo-100">
                                                    <mat-icon class="w-3.5 h-3.5 text-indigo-600">check</mat-icon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>

                        <!-- <div style="    margin-top: -11px;">
                            <span *ngIf="usrDtls.ste_nm" class="hyrch-lvl-css">{{usrDtls.ste_nm}} </span>
                            <span *ngIf="usrDtls.dstrt_nm" class="hyrch-lvl-css"> - {{usrDtls.dstrt_nm}} </span>
                            <span *ngIf="usrDtls.ulb" class="hyrch-lvl-css"> - {{usrDtls.ulb}} </span>
                            <span *ngIf="usrDtls.mndl_nm" class="hyrch-lvl-css"> - {{usrDtls.mndl_nm}}</span>
                            <span *ngIf="usrDtls.gp_nm" class="hyrch-lvl-css"> - {{usrDtls.gp_nm}} </span>
                            <span *ngIf="usrDtls.svm_nm" class="hyrch-lvl-css"> - {{usrDtls.svm_nm}} </span>
                            <span *ngIf="usrDtls.hyrchy_hndlr_tx && usrDtls.clnt_id != 1000053" class="hyrch-css">
                                (level- {{usrDtls.hyrchy_hndlr_tx}})</span>
                        </div> -->
                    </div>

                </div>
                <div class="flex" *ngFor="let h of img_data;">
                    <div *ngIf="h.hd_lgo_url_tx" class="flex lg:h-16 lg:w-16 md:h-16 md:w-16 sm:h-14 sm:w-14 mble_dvse-h-14 mble_dvse-w-14 
                        flex-0 items-center justify-center overflow-hidden rounded-full mt-1">
                        <img class="h-full w-full object-cover" [src]="h.hd_lgo_url_tx">
                    </div>
                    <div class="px-2 py-2">
                        <div class="truncate font-bold leading-1 mble_dsply_none"> {{h.hd_prmry_nm}}</div>
                        <div class="text-secondary text-sm truncate leading-1 mble_dsply_none">{{h.hd_scndry_nm}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="flex-1"></div> -->

        <!-- Components -->
        <div class="flex items-center pl-2 space-x-1 sm:space-x-2">

            <!-- <div class="flex-container">

                <div class="client-name">
                     {{clntTntDtls[0].clnt_nm}}
                </div>

                <div
                    class="flex lg:h-12 lg:w-12 md:h-12 md:w-12 sm:h-10 sm:w-10 mble_dvse-h-10 mble_dvse-w-10  flex-0 items-center justify-center overflow-hidden rounded-full mt-1">
                    <img alt="Contact avatar" class="h-full w-full object-cover" src="/assets/images/logo/apcmsir.png">

                </div>
                <div class="px-2 py-2">
                    <div class="truncate font-bold leading-1 mble_dsply_none"> Sri.Nara Chandrababu Naidu </div>
                    <div class="text-secondary text-sm truncate leading-1 mble_dsply_none"> Hon'ble Chief Minister of
                        Andhra Pradesh </div>
                </div>
            </div> -->

            <!-- <div class="flex">
                <div
                    class="flex lg:h-12 lg:w-12 md:h-12 md:w-12 sm:h-10 sm:w-10 mble_dvse-h-10 mble_dvse-w-10 flex-0 items-center justify-center overflow-hidden rounded-full mt-1">
                    <img alt="Contact avatar" class="h-full w-full object-cover"
                        src="/assets/images/logo/narayanasir_apmaud.png">
                </div>
                <div class="px-2 py-2">
                    <div class="truncate font-bold leading-1 mble_dsply_none"> Sri.Pongure Narayana </div>
                    <div class="text-secondary text-sm truncate leading-1 mble_dsply_none"> Hon'ble Minister of MA & UD
                    </div>
                </div>
            </div> -->
            <!-- <languages></languages> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <search [appearance]="'bar'"></search> -->
            <!-- <shortcuts></shortcuts> 77
            <qrscan ></qrscan>
            <notifications></notifications> -->
            <user></user>
            <mat-icon (click)="open()" matTooltip="HELP" class="clickable-icon"
                *ngIf="usrDtls && usrDtls.rle_nm !=  'BCCFC Benificary '">info</mat-icon>
        </div>
    </div>
    <!-- Horizontal navigation -->
    <fuse-horizontal-navigation class="dark bg-gray-900 print:hidden" [appearance]="navigationAppearance"
        [mode]="isScreenSmall ? 'over' : 'top'" mode="top" [name]="'mainNavigation'"
        [navigation]="navigation.horizontal" *ngIf="usrDtls && usrDtls.rle_nm ==  'BCCFC Benificary '"
        style="background: #fff !important;">

        <ng-container>
            <div style="
    font-size: 18px;
    margin: auto;
    padding: 0px 20px;
    line-height: 55px;
    font-weight: 700;">Beneficiary Loan Dashboard</div>
            <div class="flex items-center justify-center h-16" *ngIf="clntTntDtls && clntTntDtls.length"
                style="background   : #fff;    border-right: 2px solid #e7e7e7; margin: 50px;">
                <img style="width: 100%; margin-top: 0px; height: 64px;" [src]="PrfieImage">
                <img style="width:64px;height:64px ; margin: 0px auto;" [src]="PrfieImage1" *ngIf="lgimg">
            </div>
        </ng-container>
    </fuse-horizontal-navigation>
    <!-- Content -->
    <!-- <div class="flex flex-col flex-auto"> -->
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <!-- <router-outlet *ngIf="true"></router-outlet> -->
    <!-- sunitha -->
    <!-- <div class="relative flex flex-col h-full  " *ngIf="shwsbmnu">

        <mat-drawer-container class="flex-auto h-full">



           
            <mat-drawer class="w-72 dark:bg-gray-900" [mode]="drawerMode" [opened]="drawerOpened" #drawerSubMnu>

               
                <div class="flex flex-col flex-auto w-full fusecls">

                    <div class="mt-10 mb-8 mx-6 text-3xl font-extrabold tracking-tight leading-none">{{title}}</div>
                   
                    <div class="grid grid-cols-12 gap-2" style="    margin-top: 0.45rem !important;">
                        
                        <div class="col-span-12">
                            <mat-form-field class="mb-4 fuse-mat-no-subscript fuse-mat-rounded fuse-mat-dense"
                                [floatLabel]="'always'">
                                <mat-icon matPrefix class="icon-size-5" [svgIcon]="'heroicons_solid:search'"></mat-icon>
                                <input matInput [(ngModel)]="mnunm" [placeholder]="'Search '"
                                    (keyup)='debouncedSearch($event)'>
                                <button mat-icon-button matSuffix (click)="clearFltr()">
                                    <mat-icon [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                       

                   
                    <fuse-vertical-navigation [navigation]="sbmnuslst" [inner]="true" [mode]="'side'"
                        [name]="'subNavigation'" [mn_type]="'custom_menu'" [opened]="true"></fuse-vertical-navigation>
                </div>

            </mat-drawer>

           
            <mat-drawer-content class="flex flex-col overflow-hidden">

              
                <div>
                    <div class="relative flex flex-0 ">

                        <div class="flex flex-wrap w-full mx-auto d-hrd">
                            <div class="flex flex-wrap w-full  mx-auto p-2">

                                <div class=" top-card w-full">
                                    <div class="grid grid-cols-12">
                                        <div class="col-span-1" (click)="clsefrm()">
                                            <button mat-icon-button (click)="drawerSubMnu.toggle()">
                                                <mat-icon [svgIcon]="'heroicons_outline:menu'"
                                                    class="cls-icn-clr"></mat-icon>
                                            </button>
                                        </div>
                                        <div class="col-span-11">
                                          
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                </div>
                <div class="relative flex flex-col w-full h-full" fuseScrollReset>
                    <router-outlet *ngIf="true"></router-outlet>
                </div>

            </mat-drawer-content>

        </mat-drawer-container>

    </div> -->
    <div class="relative flex flex-col h-full  " fuseScrollReset>
        <router-outlet *ngIf="true"></router-outlet>

    </div>
    <!-- sunitha -->
    <!-- </div> -->

    <!-- Footer -->
    <div
        class="relative flex flex-0 items-center justify-start w-full h-8 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary" style="font-size: 12px;">
            <span> {{fter_tx ? fter_tx: 'Dreamstep Software Innovations Pvt. Ltd...'}}</span>
            &copy; {{currentYear}}</span>
    </div>

</div>


<mat-sidenav-container class="cstmIndxalgn" *ngIf="visible">
    <mat-sidenav class="w-screen min-w-screen sm:w-60 sm:min-w-2/3 cstmIndxalgn" [opened]="visible" mode="over"
        position="end" (closedStart)="closeSideBar()">
        <div class="flex flex-row items-center px-6 h-15 min-h-15 text-white common-bg justify-between bg-clr">
            <div class="ml-3 text-2xl font-semibold tracking-tight">
                {{sidebarHeadings}}
            </div>
            <div>
                <button mat-icon-button (click)="closeSideBar()" class="text-white">
                    <mat-icon class="text-white">close</mat-icon>
                </button>
            </div>
        </div>
        <div style="padding: 10px;" *ngIf="content">
            <div style="padding: 20px; text-align: justify;">
                <div class="sctin">
                    <div class="ribbon lgnd">Content</div>
                    <div [innerHTML]="content"></div>
                </div>

                <div class="sctin">
                    <div class="ribbon lgnd">Related documents and images</div>
                    <div class="flex flex-wrap gap-8 my-2" *ngIf="pageDtls?.length">
                        <div class="flex flex-row items-center border border-gray-300 rounded-md p-1 gap-3"
                            *ngFor="let data of pageDtls">
                            <div class="w-16 h-16"
                                *ngIf="data.upld_dcmnt_url_tx.includes('.jpeg') || data.upld_dcmnt_url_tx.includes('.jpg') || data.upld_dcmnt_url_tx.includes('.png')">
                                <img [src]="getFullImageUrl(data.upld_dcmnt_url_tx)" alt="No image Found"
                                    class="object-cover w-full h-full rounded-md"
                                    (click)="openDialog(data.upld_dcmnt_url_tx)" style="cursor: pointer;margin-top:1px">
                                <div class="flex flex-col flex-auto justify-center text-center text-sm font-medium">
                                    <div class="truncate" [matTooltip]="data.dcmnt_nm" matTooltipPosition="right"
                                        matTooltipClass="custom-tooltip" style="padding-top: 10px;">{{data.dcmnt_nm}}
                                    </div>
                                </div>
                            </div>
                            <div class="w-16 h-16" *ngIf="data.upld_dcmnt_url_tx.includes('.pdf')">
                                <img src="assets/images/support/pdf.png" alt="No image Found"
                                    class="object-cover w-full h-full rounded-md" style="margin-top:1px"
                                    (click)="openDialog(data.upld_dcmnt_url_tx)">
                                <div class="flex flex-col flex-auto justify-center text-center text-sm font-medium">
                                    <div class="truncate" [matTooltip]="data.dcmnt_nm" matTooltipPosition="right"
                                        matTooltipClass="custom-tooltip" style="padding-top: 10px;">{{data.dcmnt_nm}}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


    </mat-sidenav>
</mat-sidenav-container>